import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = false;

const setInitDashboard = (_, { payload }) => payload;

const setIsReady = () => true;

export default createReducer(initialState, {
  [actionTypes.SET_INIT_CHAT]: setInitDashboard,
  [actionTypes.CHAT_IS_READY]: setIsReady,
});
